import React from "react";
import AdminOrdersList from "components/orders/admin/AdminOrdersList";

export default function PageAdminOrdersList() {
  return (

    <div id="page-admin-orders-list"
      class="py-4 container-fluid pe-2">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="h4 m-0">
          <span>Commandes & factures</span>
        </h1>
      </div>


      <div className="container">
        <AdminOrdersList />
      </div>
    </div>
  );
}